/**
 * @brief   Singleton de AppAjax.
 * @see     resources/js/scripts/functions/AppAjax.class.js
 */
require('./functions/AppAjax.class');
let AppAjax = window.AppAjax;

/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief   Fonctionnalités de la page des soumissions
 */
jQuery(document).ready(function() {
    // Exécution du code uniquement si l'élément du DOM existe
    if (jQuery('section[class^=section-clients]').html() !== undefined) {
        // Méthodes JavaScript communes
        require('./functions/validators.functions');
        // Méthodes jQuery communes
        require('./jquery/adresses.jquery');
        require('./jquery/utilisateurs.jquery');
        /** DEBUT DU CODE JAVASCRIPT EN DESSOUS DE CETTE PARTIE ! */

        //#####################################################
        // Clear add customer form
        //#####################################################
        $('button.add-customer-btn').on('click', function(event) {
            event.stopPropagation();
            $('form#confirm-add-customer input:not([type=hidden])').each(function() { $(this).val(''); });
            $('form#confirm-add-customer select option:selected').each(function() { $(this).prop('selected', false); });
            // Vidage du champ des États/Provinces/Territoires
            AppAjax.clearSelectOptions('form#confirm-add-customer select[name=state]');
        });

        //#####################################################
        // Send delete customer url to the modale form action
        //#####################################################
        $('button.delete-customer-btn').on('click', function(event) {
            event.stopPropagation();
            $('form#confirm-delete-customer').attr("action", $(this).data('url'));
        });

        //#####################################################
        // Add/Remove emails de la page customer details
        //#####################################################
        $(".get-email").on("input", function(event) {
            event.stopPropagation();
            if ($(this).val().length > 0 && window.isValidEmail($(this).val())) {
                $(".add-email").removeClass("disabled").removeAttr("aria-disabled");
            } else {
                $(".add-email").addClass("disabled").attr("aria-disabled", "true");
            }
        });
        
        $('.add-email').on('click', function(event) {
            event.stopPropagation();
            var clientId = $(this).data('client');
            var newEmail = $('.get-email').val();

            // validate the email address
            if (!window.isValidEmail(newEmail)) {
                alert(window.lang === 'fr' ? 'Veuillez saisir un courriel valide.' : 'Please enter a valid email address.');
                return;
            }
        
            // check if email already exists in the list
            if ($('.email-item:contains("' + newEmail + '")').length > 0) {
                $('.get-email').val('');
                $('.add-email').addClass('disabled').attr('aria-disabled', 'true');
                $('.get-email').attr('placeholder', window.lang === 'fr' ? 'Le courriel existe déjà !' : 'Email already exists!');
                return;
            }

            // Mise à jour AJAX
            window.AppAjax.executeAction('client_cci', {
                'mode':      'add',
                'client_id': clientId,
                'email':     newEmail,
                'hidden':    true
            }, function(response) {
                // Ajout de l'entrée en cas de succès
                if (response.status === 'success') {
                    // Add email to list
                    var emailSpan = '<span>%email%&nbsp;&nbsp;<i class="bi bi-x" data-id="%id%"></i><input type="hidden" name="email[%id%]" value="%email%"></span>';
                    var newItem = $('<li class="email-item">').html(emailSpan.replace(/%id%/g, response.results.id).replace(/%email%/g, response.results.email));
                    $('.display-emails').append(newItem);

                    $('.get-email').val('');
                    $('.add-email').addClass('disabled').attr('aria-disabled', 'true');
                    $('.display-emails .empty').remove();
                }
            });
        });
        
        // when a delete button is clicked, remove the corresponding email span
        $(document).on('click', '.display-emails span i', function(event) {
            event.stopPropagation();
            var email_id   = $(this).data('id');
            var email_item = $(this).parents().find('li.email-item:first');

            // Mise à jour AJAX
            window.AppAjax.executeAction('client_cci', {
                'mode': 'delete',
                'id':   email_id
            }, function(response) {
                // Suppression de l'entrée en cas de succès
                if (response.status === 'success') {
                    email_item.remove();
                }
            });
        });


        /** FIN DU CODE JAVASCRIPT AU DESSUS DE CETTE PARTIE ! */
    }
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
